import { DASHBOARD_HOME_ROUTE } from './../../../constants/dashboar.routes.constants';


export const POSTS_LISTING_ROUTE = {
  path: '',
  get url():string{
    return `${DASHBOARD_HOME_ROUTE.url}/${this.path}`
  }
}


export const POST_DETAILS_ROUTE = {
  path:':id',
  url(id:string){
    return `${DASHBOARD_HOME_ROUTE.url}/${id}`
  }
};


export const COMMENT_DETAILS ={
  path:'comment/:id',
  url(id:string){
    return `${DASHBOARD_HOME_ROUTE.url}/comment/${id}`
  }
}
